import { render, staticRenderFns } from "./PainCategories.vue?vue&type=template&id=55b3c604&"
import script from "./PainCategories.vue?vue&type=script&lang=js&"
export * from "./PainCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports